import { OmnisearchAutocomplete } from "components/OmnisearchAutocomplete";
import { getFullName } from "encamp-shared/src/utils/name";
import { gql } from "generated-graphql";
import { SubmissionReviewerSignerPickerQuery } from "generated-graphql/graphql";
import { SubmissionReviewerSigner } from "hooks/useSubmissionForm";

interface ReviewerSignerPickerProps {
  onChange: (reviewer: SubmissionReviewerSigner | null) => void;
  value?: SubmissionReviewerSigner | null;
  disabled?: boolean;
  disabledReviewers?: SubmissionReviewerSigner[];
  staffOnly?: boolean;
  mode: "reviewer" | "signer";
}

const SUBMISSION_REVIEWER_SIGNER_PICKER_QUERY = gql(`
    query SubmissionReviewerSignerPicker($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
      users(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
        items {
          ...SubmissionReviewerPickerUser
        }
      }
    }
  `);

const STAFF_REVIEWER_SIGNER_PICKER_QUERY = gql(`
    query StaffReviewerSignerPicker($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
      users: staffUsers(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
        items {
          ...SubmissionReviewerPickerUser
        }
      }
    }
  `);

export function ReviewerSignerPicker({
  onChange,
  value,
  disabled,
  disabledReviewers,
  staffOnly = false,
  mode,
}: ReviewerSignerPickerProps) {
  return (
    <OmnisearchAutocomplete<
      SubmissionReviewerSignerPickerQuery,
      any,
      SubmissionReviewerSigner
    >
      dataQuery={
        staffOnly
          ? STAFF_REVIEWER_SIGNER_PICKER_QUERY
          : SUBMISSION_REVIEWER_SIGNER_PICKER_QUERY
      }
      getItems={(data) =>
        data?.users?.items.map((r, index) => ({
          id: r.id,
          name: r.person ? getFullName(r.person) : r.email,
          email: r.email,
          order: index + 1,
          isSigner: mode === "signer",
          isStaff: staffOnly,
        })) ?? []
      }
      getOptionLabel={(item) => {
        return item?.name !== item?.email
          ? `${item?.name} (${item?.email})`
          : item?.email;
      }}
      inputLabelProps={{
        label: mode === "signer" ? "Signer *" : "Reviewer *",
      }}
      onChange={onChange}
      value={value || null}
      disabled={disabled}
      runInitialSearch={true}
      getOptionDisabled={(item) => {
        return disabledReviewers?.some((r) => r.id === item?.id) ?? false;
      }}
      sx={{
        width: "100%",
      }}
    />
  );
}
